export { ThemeProvider as default, type ThemeProviderProps } from 'next-themes';
